import React from "react";
import { t } from "ttag";

import { IPaymentMethodFormProps } from "./PaymentMethod.interfaces";

type IProps = IPaymentMethodFormProps;

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to trivial render-only component with no state or logic.
export class Cash extends React.Component<IProps, IState> {
    render() {
        return (
            <div className="form__error">
                <p>
                    <strong>
                        {t`Please enter payment information directly into the ERP.`}
                    </strong>
                </p>
            </div>
        );
    }
}
